// @flow

import type { Action } from './store.type';

export const GET_REDIRECTS_REQUEST = 'GET_REDIRECTS_REQUEST';
type GET_REDIRECTS_REQUEST_TYPE = 'GET_REDIRECTS_REQUEST';

export const GET_REDIRECTS_SUCCESS = 'GET_REDIRECTS_SUCCESS';
type GET_REDIRECTS_SUCCESS_TYPE = 'GET_REDIRECTS_SUCCESS';

export const GET_REDIRECTS_FAILURE = 'GET_REDIRECTS_FAILURE';
type GET_REDIRECTS_FAILURE_TYPE = 'GET_REDIRECTS_FAILURE';

type RedirectType = {
  term: string,
  priority: number,
  level: number,
  searchEnabled: boolean,
  lang: string,
  tenantId: string,
  id: string,
  weight: number
};

type GetRedirectSuccess = {
  skip: number,
  limit: number,
  data: Array<RedirectType>,
  total: number
};

type GetRedirectsFailure = {
  error: any
};

type GetRedirectsRequestAction = Action<GET_REDIRECTS_REQUEST_TYPE, null>;

type GetRedirectsSuccessAction = Action<GET_REDIRECTS_SUCCESS_TYPE, GetRedirectSuccess>;

type GetRedirectsFailureAction = Action<GET_REDIRECTS_FAILURE_TYPE, GetRedirectsFailure>;

// Bulk redirects
export const BULK_REDIRECTS_REQUEST = 'BULK_REDIRECTS_REQUEST';
type BULK_REDIRECTS_REQUEST_TYPE = 'BULK_REDIRECTS_REQUEST';

export const BULK_REDIRECTS_SUCCESS = 'BULK_REDIRECTS_SUCCESS';
type BULK_REDIRECTS_SUCCESS_TYPE = 'BULK_REDIRECTS_SUCCESS';

export const BULK_REDIRECTS_FAILURE = 'BULK_REDIRECTS_FAILURE';
type BULK_REDIRECTS_FAILURE_TYPE = 'BULK_REDIRECTS_FAILURE';

type BulkRedirectsRequestAction = Action<BULK_REDIRECTS_REQUEST_TYPE, null>;

type BulkRedirectsSuccessAction = Action<BULK_REDIRECTS_SUCCESS_TYPE, BulkRedirectSuccess>;

type BulkRedirectsFailureAction = Action<BULK_REDIRECTS_FAILURE_TYPE, BulkRedirectsFailure>;

// Delete Redirects
export const DELETE_REDIRECTS_REQUEST = 'DELETE_REDIRECTS_REQUEST';
type DELETE_REDIRECTS_REQUEST_TYPE = 'DELETE_REDIRECTS_REQUEST';

export const DELETE_REDIRECTS_SUCCESS = 'DELETE_REDIRECTS_SUCCESS';
type DELETE_REDIRECTS_SUCCESS_TYPE = 'DELETE_REDIRECTS_SUCCESS';

export const DELETE_REDIRECTS_FAILURE = 'DELETE_REDIRECTS_FAILURE';
type DELETE_REDIRECTS_FAILURE_TYPE = 'DELETE_REDIRECTS_FAILURE';

type DeleteRedirectsRequestAction = Action<DELETE_REDIRECTS_REQUEST_TYPE, null>;

type DeleteRedirectsSuccessAction = Action<DELETE_REDIRECTS_SUCCESS_TYPE, DeleteRedirectsSuccess>;

type DeleteRedirectsFailureAction = Action<DELETE_REDIRECTS_FAILURE_TYPE, DeleteRedirectsFailure>;

// Update Redirect
export const UPDATE_REDIRECT_REQUEST = 'UPDATE_REDIRECT_REQUEST';
type UPDATE_REDIRECT_REQUEST_TYPE = 'UPDATE_REDIRECT_REQUEST';

export const UPDATE_REDIRECT_SUCCESS = 'UPDATE_REDIRECT_SUCCESS';
type UPDATE_REDIRECT_SUCCESS_TYPE = 'UPDATE_REDIRECT_SUCCESS';

export const UPDATE_REDIRECT_FAILURE = 'UPDATE_REDIRECT_FAILURE';
type UPDATE_REDIRECT_FAILURE_TYPE = 'UPDATE_REDIRECT_FAILURE';

type UpdateRedirectRequestAction = Action<UPDATE_REDIRECT_REQUEST_TYPE, null>;

type UpdateRedirectSuccessAction = Action<UPDATE_REDIRECT_SUCCESS_TYPE, UpdateRedirectSuccess>;

type UpdateRedirectFailureAction = Action<UPDATE_REDIRECT_FAILURE_TYPE, UpdateRedirectFailure>;

// Vefify csv file before importing
export const VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_REQUEST =
  'VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_REQUEST';
type VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_REQUEST_TYPE =
  'VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_REQUEST';

export const VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_SUCCESS =
  'VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_SUCCESS';
type VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_SUCCESS_TYPE =
  'VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_SUCCESS';

export const VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_FAILURE =
  'VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_FAILURE';
type VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_FAILURE_TYPE =
  'VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_FAILURE';

type VerifyContentBeforeImportRequestAction = Action<
  VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_REQUEST_TYPE,
  null
>;

type VerifyContentBeforeImportSuccessAction = Action<
  VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_SUCCESS_TYPE,
  VerifyContentBeforeImportSuccess
>;

type VerifyContentBeforeImportFailureAction = Action<
  VERIFY_CONTENT_REDIRECT_BEFORE_IMPORT_FAILURE_TYPE,
  VerifyContentBeforeImportFailure
>;

// Import file
export const IMPORT_FILE_REDIRECT_REQUEST = 'IMPORT_FILE_REDIRECT_REQUEST';
type IMPORT_FILE_REDIRECT_REQUEST_TYPE = 'IMPORT_FILE_REDIRECT_REQUEST';

export const IMPORT_FILE_REDIRECT_SUCCESS = 'IMPORT_FILE_REDIRECT_SUCCESS';
type IMPORT_FILE_REDIRECT_SUCCESS_TYPE = 'IMPORT_FILE_REDIRECT_SUCCESS';

export const IMPORT_FILE_REDIRECT_FAILURE = 'IMPORT_FILE_REDIRECT_FAILURE';
type IMPORT_FILE_REDIRECT_FAILURE_TYPE = 'IMPORT_FILE_REDIRECT_FAILURE';

type ImportFileRequestAction = Action<IMPORT_FILE_REDIRECT_REQUEST_TYPE, null>;

type ImportFileSuccessAction = Action<IMPORT_FILE_REDIRECT_SUCCESS_TYPE, ImportFileSuccess>;

type ImportFileFailureAction = Action<IMPORT_FILE_REDIRECT_FAILURE_TYPE, ImportFileFailure>;

// Export file
export const EXPORT_FILE_REDIRECT_REQUEST = 'EXPORT_FILE_REDIRECT_REQUEST';
type EXPORT_FILE_REDIRECT_REQUEST_TYPE = 'EXPORT_FILE_REDIRECT_REQUEST';

export const EXPORT_FILE_REDIRECT_SUCCESS = 'EXPORT_FILE_REDIRECT_SUCCESS';
type EXPORT_FILE_REDIRECT_SUCCESS_TYPE = 'EXPORT_FILE_REDIRECT_SUCCESS';

export const EXPORT_FILE_REDIRECT_FAILURE = 'EXPORT_FILE_REDIRECT_FAILURE';
type EXPORT_FILE_REDIRECT_FAILURE_TYPE = 'EXPORT_FILE_REDIRECT_FAILURE';

type ExportFileRequestAction = Action<EXPORT_FILE_REDIRECT_REQUEST_TYPE, null>;

type ExportFileSuccessAction = Action<EXPORT_FILE_REDIRECT_SUCCESS_TYPE, ExportFileSuccess>;

type ExportFileFailureAction = Action<EXPORT_FILE_REDIRECT_FAILURE_TYPE, ExportFileFailure>;

// Action and State
export type RedirectsAction =
  | GetRedirectsRequestAction
  | GetRedirectsSuccessAction
  | GetRedirectsFailureAction
  | BulkRedirectsRequestAction
  | BulkRedirectsSuccessAction
  | BulkRedirectsFailureAction
  | DeleteRedirectsRequestAction
  | DeleteRedirectsSuccessAction
  | DeleteRedirectsFailureAction
  | UpdateRedirectRequestAction
  | UpdateRedirectSuccessAction
  | UpdateRedirectFailureAction
  | VerifyContentBeforeImportRequestAction
  | VerifyContentBeforeImportSuccessAction
  | VerifyContentBeforeImportFailureAction
  | ImportFileRequestAction
  | ImportFileSuccessAction
  | ImportFileFailureAction
  | ExportFileRequestAction
  | ExportFileSuccessAction
  | ExportFileFailureAction;

export type RedirectsState = {
  loading: boolean,
  success: boolean,
  successFlag: number,
  error: null,
  redirects: Array<RedirectType> | [],
  total: number,
  saving: boolean,

  // Verify file content
  verifying: boolean,
  fileContentErrorCode: string,
  totalRecord: number,

  // Import file content
  importing: boolean,
  totalImportedRecords: number
};
